import React from 'react'

import { Icon, ArrowRight, ChevronLeft, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { array, string, bool, func } from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

const CHEVRON_SIZE = { width: '16', height: '16' }
const ARROW_SIZE = { width: '16', height: '16' }

// Secondary submenu revealed when a category is hovered (desktop) or its chevron is
// tapped (mobile). One markup, two presentations driven by CSS: a compact floating
// popover to the right of the row at md+, and a full-width push panel with a back
// header below md (matching the Figma mobile drill-in). Open/close is JS-driven by
// the parent's useSubcategoryMenu so it mirrors the legacy behaviour.
//
// On mobile the flyout overlays the whole panel; the back header and the "All X" browse
// link share one space-between row (the `__flyout-header`) so the browse link keeps the
// same top-right position it has beside the default-view Categories heading.
function SubcategoryFlyout({
  id = undefined,
  subcategories,
  categoryTitle = '',
  isOpen,
  onClose = NOOP,
  onLinkClick = NOOP,
  browseAllHref = undefined,
  browseAllLabel = undefined,
}) {
  const items = subcategories.filter(Boolean)

  return (
    <div
      id={id}
      className={classnames(
        'category-mega-menu__flyout',
        isOpen && 'category-mega-menu__flyout--open'
      )}
    >
      {/* The header only exists while the flyout is open: the subcategory links below
          stay server-rendered for crawlers, but the back button and the duplicate
          "browse all" link (also in the panel header) would otherwise add two icons and
          ~10 nodes per category to every page for a panel that starts closed. */}
      {isOpen && (
        <div className="category-mega-menu__flyout-header">
          <button
            type="button"
            className="category-mega-menu__flyout-back"
            onClick={onClose}
          >
            <Icon notSpaced color="dark" size={CHEVRON_SIZE} svgComponent={ChevronLeft} />
            <span className="category-mega-menu__flyout-back-label cgt-overline-md">{categoryTitle}</span>
          </button>
          {browseAllHref && browseAllLabel && (
            <a href={browseAllHref} className="category-mega-menu__browse-inline cgt-button-text-md-semibold">
              <span className="category-mega-menu__browse-inline-label">{browseAllLabel}</span>
              <Icon notSpaced color="dark" size={ARROW_SIZE} svgComponent={ArrowRight} />
            </a>
          )}
        </div>
      )}
      <ul className="category-mega-menu__flyout-list">
        {items.map((subcategory) => (
          <li key={subcategory.title || subcategory.name} className="category-mega-menu__flyout-item">
            <a
              href={subcategory.path}
              className="category-mega-menu__flyout-link cgt-body-base-semibold"
              onClick={(event) => onLinkClick(event, subcategory.path)}
            >
              <span className="category-mega-menu__flyout-link-label">
                {subcategory.title || subcategory.name}
              </span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

SubcategoryFlyout.propTypes = {
  id: string,
  subcategories: array.isRequired,
  categoryTitle: string,
  isOpen: bool.isRequired,
  onClose: func,
  onLinkClick: func,
  browseAllHref: string,
  browseAllLabel: string,
}

export default SubcategoryFlyout
